import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'antd';
import { EditOrganizationProfileModal } from 'works/components/edit-organization-profile';
import { Gap, Icon } from '@common/components';
import { toUSFormat } from 'works/legacy/lib/date-helper';

export default function EditConversionDate({
  conversionDate,
  estimatedConversionDate,
  organizationProfileId,
  canUpdate,
  isInternational,
}) {
  const [showOrganizationProfileModal, setShowOrganizationProfileModal] =
    useState(false);
  const formattedConversionDate = conversionDate
    ? toUSFormat(conversionDate)
    : null;
  const formattedEstimatedConversionDate = estimatedConversionDate
    ? toUSFormat(estimatedConversionDate)
    : null;
  const openEditModalOnClick = (children) => (
    <a onClick={() => setShowOrganizationProfileModal(true)}>{children}</a>
  );

  return (
    <Row>
      {isInternational && !formattedConversionDate && (
        <Col>
          {formattedEstimatedConversionDate ? (
            <Gap align="center">
              <Icon
                icon="calendarCheck"
                kind="light"
                size="sm"
                tooltipText="Estimated Conversion Date"
              />
              {'Est. Conversion: '}
              {canUpdate
                ? openEditModalOnClick(formattedEstimatedConversionDate)
                : formattedEstimatedConversionDate}
            </Gap>
          ) : (
            canUpdate && (
              <Gap align="center">
                <Icon
                  icon="calendarCheck"
                  kind="light"
                  size="sm"
                  tooltipText="Estimated Conversion Date"
                />
                {openEditModalOnClick('Est. Conversion Date')}
              </Gap>
            )
          )}
        </Col>
      )}
      <Col>
        <EditOrganizationProfileModal
          visible={showOrganizationProfileModal}
          onClose={() => setShowOrganizationProfileModal(false)}
          organizationProfileId={organizationProfileId}
        />
        {formattedConversionDate ? (
          <Gap align="center">
            <Icon
              icon="calendarCheck"
              kind="light"
              size="sm"
              tooltipText="Conversion Date"
            />
            {'Conversion: '}
            {canUpdate
              ? openEditModalOnClick(formattedConversionDate)
              : formattedConversionDate}
          </Gap>
        ) : (
          canUpdate && (
            <Gap align="center">
              <Icon
                icon="calendarCheck"
                kind="light"
                size="sm"
                tooltipText="Conversion Date"
              />
              {openEditModalOnClick('Conversion Date')}
            </Gap>
          )
        )}
      </Col>
    </Row>
  );
}

EditConversionDate.propTypes = {
  conversionDate: PropTypes.string,
  isInternational: PropTypes.bool,
  estimatedConversionDate: PropTypes.string,
  organizationProfileId: PropTypes.string.isRequired,
  canUpdate: PropTypes.bool,
};

EditConversionDate.defaultProps = {
  canUpdate: false,
};
